import { isErrorWithData } from 'redux-store/helpers/is-error-with-data';
import useToast from './useToast';

export const useCatchServerError = () => {
  const showToast = useToast();

  const catchError = (err: unknown) => {
    const message =
      isErrorWithData(err) && err.data.message?.length
        ? err.data.message
        : 'Something went wrong.  Please try again or contact support for help.';

    showToast({
      type: 'error',
      message,
    });
  };

  return { catchError };
};
